import { authSlice } from 'common/commonRedux/auth/slice';
import { localStorageSlice } from 'common/commonRedux/reduxForLocalStorage/slice';
import { combineReducers } from 'redux';
import { apiCalling } from '../commonRedux/getRTKApi/baseApi';
import filterReducer from "../commonRedux/feature/filteringSlice"
import themeReducer from "../commonRedux/feature/themeSlice"
import dateFormatter from "../commonRedux/feature/dateFormatterSlilce"
import empListReducer from "../commonRedux/feature/empListSlice"
import fontSizeReducer from "../commonRedux/feature/fontSizeSlice"
import { rustApiCalling } from 'common/commonRedux/getRTKApi/rustApi';

export const rootReducer = combineReducers({
  localStorage: localStorageSlice.reducer,
  [apiCalling.reducerPath]: apiCalling.reducer,
  [rustApiCalling.reducerPath]: rustApiCalling.reducer,
  auth: authSlice.reducer,
  filter: filterReducer,
  empList:empListReducer,
  theme:themeReducer,
  dateFormatter,
  fontSize: fontSizeReducer,
});
